import { render, staticRenderFns } from "./suDetailReportList.vue?vue&type=template&id=464d2660"
import script from "./suDetailReportList.vue?vue&type=script&lang=js"
export * from "./suDetailReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports